let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gL84Y")).then(() => parcelRequire('OOVjL'));